import { ButtonProps, Modal } from "antd";
import React from "react";

import { useTranslation } from "@opendash/core";
import { createComponent } from "@opendash/state";

import { Map, MapProps } from "./Map";

const okButtonProps: ButtonProps = {
  style: {
    display: "none",
  },
};

type MapModalProps = Omit<MapProps, "width" | "height"> & {
  width?: number | string;
  height?: number | string;
  open: boolean;
  onCancel(): void;
  onSave?(): void;
};

export const MapModal = createComponent<MapModalProps>(function MapModal({
  open,
  onCancel,
  onSave,
  width = Math.min(window.innerWidth, 1200),
  height = Math.min(window.innerHeight * 0.7, 1000),
  children,
  ...props
}) {
  const t = useTranslation();

  return (
    <Modal
      open={true}
      onOk={onSave}
      okText={t("opendash:ui.save")}
      onCancel={onCancel}
      cancelText={t("opendash:ui.close")}
      styles={{ body: { padding: 0 } }}
      okButtonProps={!onSave ? okButtonProps : undefined}
      forceRender={false}
      width={width}
    >
      {open && (
        <Map height={height} width="100%" {...props}>
          {children}
        </Map>
      )}
    </Modal>
  );
});
